import { Department } from '@interfaces/Department';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';
import { Resource } from '@interfaces/Resource';

export class DepartmentVM {
  responsible: Resource;
  isAssociatedToAllStructures: boolean;
  isSelected: boolean;

  public constructor(
    public department: Department,
    public deptEstim?: DepartmentEstimate,
  ) {
    this.isSelected = !!deptEstim
    
    this.responsible = deptEstim?.responsible;
    this.isAssociatedToAllStructures =  deptEstim?.isAssociatedToAllStructures ?? false
  }
}
